import React from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../../../components';
import ComingSoonTag from '../../../components/ComingSoonTag';

type CyberModuleCardOptionProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  link: string;
  isActive: boolean;
};

export const CyberModuleCard = ({
  icon,
  title,
  description,
  link,
  isActive,
}: CyberModuleCardOptionProps) => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-[10px] p-4 mb-4 border border-[#E5E5E5]">
      <div className="grid grid-cols-[50px,1fr,auto] gap-3 items-center">
        <div>{icon}</div>
        <div>
          <h3 className="text-lg font-bold text-primary-100">{title}</h3>
          <p className="text-[#979797]">{description}</p>
        </div>
        <div className="flex items-center gap-2">
          {!isActive && <ComingSoonTag />}
          <Button
            type="secondary"
            disabled={!isActive}
            className="lg:min-w-[130px] py-1.5 font-bold"
            onClick={() => navigate(link)}
          >
            Visit
          </Button>
        </div>
      </div>
    </div>
  );
};
